import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import TextInput from '../../../components/UIComponent/TextInput';
import BalanceSheetUI from './BalanceSheetUI';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import DailyReportsServices from '../../../services/axiosServices/apiServices/DailyReportsServices';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { CommonValidationMessages } from '../../../utils/Messages';
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import { getFinancialYearDates } from '../../../utils/DateUtils';

export default class BalanceSheet extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.dailyReportsServices = new DailyReportsServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.state = {
            idCompany: 0,
            idUser: 0,
            route: null,
            balanceObject: {
                fromDate: "",
                toDate: "",
                includeZero: false
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                fromDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "fromDate"
                        ),
                    },
                ],
                toDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "toDate"
                        ),
                    },
                ],
            },
            balanceSheetData: {
                assets: [
                    // {
                    //     title: "Fixed Assets",
                    //     total: 14850000,
                    //     items: [
                    //         {
                    //             name: "Land",
                    //             amount: 6000000,
                    //             sub: [
                    //                 { name: "Agricultural Land", amount: 3500000 },
                    //                 { name: "Commercial Plot", amount: 2500000 },
                    //             ],
                    //         },
                    //         {
                    //             name: "Building",
                    //             amount: 5200000,
                    //             sub: [
                    //                 { name: "Factory Building", amount: 3200000 },
                    //                 { name: "Office Premises", amount: 2000000 },
                    //             ],
                    //         },
                    //         {
                    //             name: "Plant & Machinery",
                    //             amount: 2800000,
                    //             sub: [
                    //                 { name: "Heavy Machinery", amount: 1800000 },
                    //                 { name: "Assembly Units", amount: 1000000 },
                    //             ],
                    //         },
                    //         {
                    //             name: "Office Equipment",
                    //             amount: 450000,
                    //             sub: [
                    //                 { name: "Heavy Machinery", amount: 1800000 },
                    //                 { name: "Assembly Units", amount: 1000000 },
                    //             ],
                    //         },   // ← No sub = plain row
                    //         { name: "Computer Systems", amount: 400000 },
                    //     ],
                    // },
                    // {
                    //     title: "Intangible Assets",
                    //     total: 1200000,
                    //     items: [
                    //         { name: "Software Licenses", amount: 700000 },
                    //         { name: "Brand Value", amount: 500000 },
                    //     ],
                    // },
                    // {
                    //     title: "Current Assets",
                    //     total: 5350000,
                    //     items: [
                    //         {
                    //             name: "Inventory / Stock",
                    //             amount: 2400000,
                    //             sub: [
                    //                 { name: "Raw Materials", amount: 900000 },
                    //                 { name: "Work-in-Progress", amount: 600000 },
                    //                 { name: "Finished Goods", amount: 900000 },
                    //             ],
                    //         },
                    //         { name: "Trade Receivables", amount: 1650000 },
                    //         { name: "Cash-In-Hand", amount: 300000 },
                    //         { name: "Bank Balance", amount: 1000000 },
                    //     ],
                    // },
                    // {
                    //     title: "Loans & Advances (Assets)",
                    //     total: 900000,
                    //     items: [
                    //         { name: "Staff Advances", amount: 250000 },
                    //         { name: "Security Deposits", amount: 650000 },
                    //     ],
                    // },
                    // {
                    //     title: "Profit & Loss",
                    //     total: 1800000,
                    //     items: [
                    //         { name: "Net Profit (Current Year)", amount: 1200000 },
                    //         { name: "Net Profit (Previous Year)", amount: 600000 },
                    //     ],
                    // },
                ],

                liabilities: [
                    // {
                    //     title: "Capital Accounts",
                    //     total: 12000000,
                    //     items: [
                    //         {
                    //             name: "Owner Capital",
                    //             amount: 8000000,
                    //             sub: [
                    //                 { name: "Initial Capital", amount: 5000000 },
                    //                 { name: "Capital Introduced", amount: 3000000 },
                    //             ],
                    //         },
                    //         { name: "Additional Capital", amount: 4000000 },
                    //     ],
                    // },
                    // {
                    //     title: "Reserves & Surplus",
                    //     total: 2650000,
                    //     items: [
                    //         { name: "General Reserve", amount: 1500000 },
                    //         { name: "Retained Earnings", amount: 1150000 },
                    //     ],
                    // },
                    // {
                    //     title: "Secured Loans",
                    //     total: 4200000,
                    //     items: [
                    //         {
                    //             name: "Bank Term Loan",
                    //             amount: 3000000,
                    //             sub: [
                    //                 { name: "HDFC Term Loan", amount: 1800000 },
                    //                 { name: "SBI Term Loan", amount: 1200000 },
                    //             ],
                    //         },
                    //         { name: "Vehicle Loan", amount: 1200000 },
                    //     ],
                    // },
                    // {
                    //     title: "Unsecured Loans",
                    //     total: 1500000,
                    //     items: [
                    //         { name: "Short-Term Loan", amount: 1500000 },
                    //     ],
                    // },
                    // {
                    //     title: "Current Liabilities",
                    //     total: 3050000,
                    //     items: [
                    //         {
                    //             name: "Trade Payables",
                    //             amount: 1800000,
                    //             sub: [
                    //                 { name: "Domestic Suppliers", amount: 1200000 },
                    //                 { name: "Import Payables", amount: 600000 },
                    //             ],
                    //         },
                    //         { name: "GST Payable", amount: 650000 },
                    //         { name: "TDS Payable", amount: 300000 },
                    //         { name: "Outstanding Expenses", amount: 300000 },
                    //     ],
                    // },
                    // {
                    //     title: "Profit & Loss",
                    //     total: 1800000,
                    //     items: [
                    //         { name: "Net Profit (Transferred)", amount: 1800000 },
                    //     ],
                    // },
                ],

                totalAssets: 0,
                totalLiabilities: 0,
            }
        }
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                let requestDetails = localStorage.getItem("balanceSheetReportDetails");
                if (requestDetails) {
                    requestDetails = JSON.parse(requestDetails);
                    requestDetails.fromDate = requestDetails.fromDate ? moment(requestDetails.fromDate).format('YYYY-MM-DD') : "";
                    requestDetails.toDate = requestDetails.toDate ? moment(requestDetails.toDate).format('YYYY-MM-DD') : "";

                    let details = this.state.balanceObject
                    details.fromDate = requestDetails.fromDate ? moment(requestDetails.fromDate).format('YYYY-MM-DD') : "";
                    details.toDate = requestDetails.toDate ? moment(requestDetails.toDate).format('YYYY-MM-DD') : "";
                    this.setState({ balanceObject: details }, () => {
                        this.getBalanceSheetReport()
                    })
                } else {
                    let details = this.state.balanceObject
                    details.fromDate = getFinancialYearDates().fromDate;
                    details.toDate = getFinancialYearDates().toDate;
                    this.setState({ balanceObject: details })
                }
            });
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.balanceObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.balanceObject;
        if (name === 'includeZero') {
            let checked = event.target.checked
            details.includeZero = checked
        } else {
            details[name] = value;
        }
        this.setState({ balanceObject: details }, () => {
            if (name === 'includeZero') {
                this.getBalanceSheetReport()
            }
        });
    }

    getBalanceSheetReport = () => {
        let isValid = this.isValidAllFields();
        if (isValid) {
            let request = {
                fromDate: this.state.balanceObject.fromDate,
                toDate: this.state.balanceObject.toDate,
                idCompany: this.state.idCompany
            };

            this.dailyReportsServices.getBalanceSheetReport(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let result = response.responseItem.responseContent;

                    const plHeads = result[1].filter(h => h.idAccountGroup === 6);

                    const totalPLExpenses = plHeads
                        .filter(h => h.accountHeadDesc === 'E')
                        .reduce((sum, h) => sum + (Math.abs(h.headTotal)), 0);

                    const totalPLIncome = plHeads
                        .filter(h => h.accountHeadDesc === 'I')
                        .reduce((sum, h) => sum + (Math.abs(h.headTotal)), 0);

                    const netPL = totalPLIncome - totalPLExpenses;
                    const isNetLoss = netPL > 0;

                    const plGroupRow = {
                        idAccountGroup: 6,
                        title: 'PROFIT & LOSS',
                        isPLGroup: true,
                        side: isNetLoss ? 'L' : 'L',
                        total: Math.abs(netPL),
                        netPL: netPL,
                        isNetLoss: isNetLoss,

                        items: result[1]
                            .filter(h => h.idAccountGroup === 6)
                            .filter(h => this.state.balanceObject.includeZero ? true : h.headTotal !== 0)
                            .map(h => ({
                                ...h,
                                name: h.accountHead,
                                amount: h.headTotal,
                                accountHeadDesc: h.accountHeadDesc,

                                sub: result[2]
                                    .filter(p => p.idAccountHead === h.idAccountHead)
                                    .filter(p => this.state.balanceObject.includeZero ? true : p.productAmount !== 0)
                                    .map(p => ({
                                        name: p.productName,
                                        amount: p.productAmount,
                                        idGeneralProduct: p.idGeneralProduct
                                    }))
                            }))
                    };

                    const otherGroups = result[0]
                        .filter(g => g.idAccountGroup !== 6)
                        .map(g => {
                            const side = g.accountGroupDesc;

                            return {
                                ...g,
                                title: g.accountGroup,
                                total: g.groupTotal,
                                side: side,

                                items: result[1]
                                    .filter(h => h.idAccountGroup === g.idAccountGroup)
                                    .filter(h => this.state.balanceObject.includeZero
                                        ? true
                                        : h.headTotal !== 0)
                                    .map(h => ({
                                        ...h,
                                        name: h.accountHead,
                                        amount: h.headTotal,

                                        sub: result[2]
                                            .filter(p => p.idAccountHead === h.idAccountHead)
                                            .filter(p => this.state.balanceObject.includeZero
                                                ? true
                                                : p.productAmount !== 0)
                                            .map(p => ({
                                                name: p.productName,
                                                amount: p.productAmount,
                                                idGeneralProduct: p.idGeneralProduct
                                            }))
                                    }))
                            };
                        });

                    const assets = otherGroups.filter(g => g.side === 'A');
                    const liabilities = otherGroups.filter(g => g.side === 'L');

                    if (isNetLoss) {
                        liabilities.push(plGroupRow);
                    } else {
                        liabilities.push(plGroupRow);
                    }

                    let balanceSheetData = this.state.balanceSheetData;
                    balanceSheetData.assets = assets;
                    balanceSheetData.liabilities = liabilities;
                    balanceSheetData.totalAssets = assets.reduce((sum, g) => sum + (g.total || 0), 0);
                    balanceSheetData.totalLiabilities = liabilities.reduce((sum, g) => sum + (g.total || 0), 0);

                    this.setState({ balanceSheetData }, () => {
                        localStorage.removeItem("balanceSheetReportDetails");
                    });
                }
            });
        }
    }

    redirectToLedger = (data) => {
        let requestDetails = {
            fromDate: this.state.balanceObject.fromDate,
            toDate: this.state.balanceObject.toDate,
            partyId: data.idGeneralProduct,
            exponseById: 4
        }
        localStorage.setItem("accountHeadSummary", JSON.stringify(requestDetails));
        this.setState({ route: '/account-head-summary' });
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='balancesheet-report'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <BalanceSheetUI
                            balanceObject={this.state.balanceObject}
                            validState={this.state.validState}
                            handleChange={this.handleChange.bind(this)}
                            balanceSheetData={this.state.balanceSheetData}
                            getBalanceSheetReport={this.getBalanceSheetReport.bind(this)}
                            redirectToLedger={this.redirectToLedger.bind(this)}
                        />
                    </div>
                </div>
            </div>
        )
    }
}